import api from "!../node_modules/.pnpm/style-loader@2.0.0_webpack@5.108.3/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../node_modules/.pnpm/css-loader@5.2.7_webpack@5.108.3/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.15_webpack@5.108.3/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./index.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};